import React from "react";
import type { RoundCost } from "@/lib/api/apps/types";
import { usdMicros } from "../app-format";
import { splitUsage } from "./draft-helpers";

/** What rounds spent, by kind of token: the overlay on a cost, for rounds
 *  that recorded the split. */
export const UsageCard: React.FC<{
  costs: RoundCost[];
  title: React.ReactNode;
}> = ({ costs, title }) => {
  const { lines, micros } = splitUsage(costs);
  const row = (label: string, n: number | null, cost: string) => (
    <React.Fragment key={label}>
      <span className={n === null ? "text-fg" : "text-fg-muted"}>{label}</span>
      <span className="font-mono text-right">{n?.toLocaleString()}</span>
      <span className="font-mono text-right">{cost}</span>
    </React.Fragment>
  );
  return (
    <div className="flex flex-col gap-1.5" style={{ whiteSpace: "normal" }}>
      <span className="text-fg-muted">{title}</span>
      <div
        className="grid gap-x-4 gap-y-0.5 items-baseline"
        style={{ gridTemplateColumns: "auto auto auto" }}
      >
        {lines.map((l) => row(l.label, l.tokens, usdMicros(l.micros)))}
        <span
          className="border-t col-span-3 my-1"
          style={{ borderColor: "var(--color-border)" }}
        />
        {row("Total", null, usdMicros(micros))}
      </div>
    </div>
  );
};
